import React from 'react';
import styled from 'styled-components';
import { Color } from 'core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface ContentTypeCardProps {
  title: string;
  description: string;
  icon: IconDefinition;
  iconColor: string;
  onClick?: () => void;
}

export const ContentTypeCard = ({ title, description, icon, iconColor, onClick }: ContentTypeCardProps) => {
  return (
    <Card onClick={onClick}>
      <IconContainer color={iconColor}>
        <FontAwesomeIcon icon={icon} />
      </IconContainer>
      <ContentInfo>
        <ContentTitle>{title}</ContentTitle>
        <ContentDescription>{description}</ContentDescription>
      </ContentInfo>
    </Card>
  );
};

const Card = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 24px;
  border: 2px solid #767676;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${Color.primaryBlue};
    background-color: #f8f9ff;
  }
`;

const IconContainer = styled.div<{ color: string }>`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${(props) => props.color}20;
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
`;

const ContentInfo = styled.div`
  flex: 1;
`;

const ContentTitle = styled.h3`
  font-size: 20px;
  color: ${Color.primaryBlack};
  margin: 0 0 8px 0;
  font-weight: 600;
`;

const ContentDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
`;